export default __webpack_public_path__ + "static/Map-3801c471654c775bf4fb7641df49bb7e.png";